/**
 * Static-translations for el. Generated from:
 *  - `online/lang/static-translations.ts` (legacy, via KEY_MAP)
 *  - `tools/sdk-translations.mjs` (SDK-specific strings)
 *
 * Do not edit by hand — changes are lost on the next `node tools/gen-locales.mjs`.
 * To fix a translation, edit legacy/sdk-translations.mjs and regenerate.
 */
const el = {
  'anon.heading_default': 'Συνέχεια ως επισκέπτης',
  'anon.try_again': 'Δοκιμάστε ξανά',
  'auth.back_to_login': 'Πίσω στη σύνδεση',
  'auth.check_email_message': 'Ελέγξτε το email σας για τον κωδικό επιβεβαίωσης.',
  'auth.check_email_title': 'Ελέγξτε το email σας',
  'auth.confirm_email_title': 'Επιβεβαιώστε το email σας',
  'auth.confirmation_code': 'Κωδικός επιβεβαίωσης',
  'auth.continue_with_apple': 'Συνέχεια με Apple',
  'auth.continue_with_facebook': 'Συνέχεια με Facebook',
  'auth.continue_with_github': 'Συνέχεια με GitHub',
  'auth.continue_with_google': 'Συνέχεια με Google',
  'auth.create_account': 'Δημιουργία λογαριασμού',
  'auth.default_subtitle': 'Συνδεθείτε για πρόσβαση σε όλες τις λειτουργίες και συγχρονισμό των δεδομένων σας.',
  'auth.email': 'Διεύθυνση email',
  'auth.email_already_registered': 'Αυτό το email είναι ήδη εγγεγραμμένο. Συνδεθείτε παρακάτω με τον κωδικό σας ή τον λογαριασμό με τον οποίο εγγραφήκατε.',
  'auth.email_exists': 'Υπάρχει ήδη λογαριασμός με αυτό το email.',
  'auth.email_not_confirmed': 'Επιβεβαιώστε πρώτα το email σας.',
  'auth.forgot_password': 'Ξεχάσατε τον κωδικό;',
  'auth.forgot_password_title': 'Ξεχάσατε τον κωδικό;',
  'auth.forgot_subtitle': 'Εισάγετε το email σας και θα σας στείλουμε σύνδεσμο επαναφοράς κωδικού.',
  'auth.generic_error': 'Κάτι πήγε στραβά',
  'auth.have_account': 'Έχετε λογαριασμό;',
  'auth.hide_password': 'Απόκρυψη κωδικού',
  'auth.identity_already_linked': 'Αυτός ο λογαριασμός είναι ήδη εγγεγραμμένος. Συνδεθείτε με αυτόν παρακάτω.',
  'auth.invalid_credentials': 'Λάθος email ή κωδικός',
  'auth.invalid_otp': 'Ο κωδικός είναι άκυρος ή έληξε.',
  'auth.last_used': 'Τελευταία χρήση · {email}',
  'auth.last_used_no_email': 'Τελευταία χρήση',
  'auth.link_purchase_subheading': 'Θα συνδέσουμε την αγορά με τον λογαριασμό σας για να διατηρηθεί η πρόσβαση.',
  'auth.log_in': 'Σύνδεση',
  'auth.log_in_link': 'Σύνδεση',
  'auth.login_continue_purchase': 'Συνδεθείτε για να συνεχίσετε την αγορά σας',
  'auth.network_error': 'Σφάλμα δικτύου. Ελέγξτε τη σύνδεση και δοκιμάστε ξανά.',
  'auth.no_account': 'Δεν έχετε λογαριασμό;',
  'auth.or': 'ή',
  'auth.password': 'Κωδικός',
  'auth.passwords_mismatch': 'Οι κωδικοί δεν ταιριάζουν',
  'auth.rate_limited': 'Πολλά αιτήματα. Δοκιμάστε ξανά αργότερα.',
  'auth.repeat_password': 'Επανάληψη κωδικού',
  'auth.reset_link_valid': 'Ο σύνδεσμος ισχύει για 1 ώρα.',
  'auth.reset_password_title': 'Επαναφορά κωδικού',
  'auth.reset_sent_message': 'Αν αυτό το email υπάρχει, εστάλη κωδικός επαναφοράς.',
  'auth.reset_sent_subtitle': 'Στείλαμε σύνδεσμο επαναφοράς κωδικού. Ακολουθήστε τις οδηγίες στο email.',
  'auth.restore_purchases_heading': 'Επαναφορά αγορών',
  'auth.restore_purchases_subheading': 'Παρακαλώ συνδεθείτε για να επαναφέρετε τις αγορές σας.',
  'auth.send_reset': 'Αποστολή email επαναφοράς',
  'auth.service_unavailable': 'Η υπηρεσία είναι προσωρινά μη διαθέσιμη. Δοκιμάστε αργότερα.',
  'auth.show_password': 'Εμφάνιση κωδικού',
  'auth.sign_out': 'Αποσύνδεση',
  'auth.sign_up': 'Εγγραφή',
  'auth.sign_up_link': 'Εγγραφή',
  'auth.signed_in': 'Συνδεδεμένος',
  'auth.signin_failed': 'Η σύνδεση απέτυχε',
  'auth.signup_failed': 'Η εγγραφή απέτυχε',
  'auth.verify': 'Επιβεβαίωση',
  'auth.weak_password': 'Ο κωδικός είναι πολύ αδύναμος.',
  'auth.welcome': 'Καλώς ήρθατε!',
  'auth.welcome_signup': 'Καλώς ήρθατε!',
  'countdown.d': 'η',
  'countdown.h': 'ω',
  'countdown.m': 'λ',
  'countdown.s': 'δ',
  'cta.close': 'Κλείσιμο',
  'cta.continue': 'Συνέχεια',
  'cta.get_lifetime_access': 'Απόκτηση ισόβιας πρόσβασης',
  'cta.get_plan_daily': 'Λήψη ημερήσιου πλάνου',
  'cta.get_plan_monthly': 'Λήψη μηνιαίου πλάνου',
  'cta.get_plan_weekly': 'Λήψη εβδομαδιαίου πλάνου',
  'cta.get_plan_yearly': 'Λήψη ετήσιου πλάνου',
  'cta.start_trial': 'Ξεκινήστε δωρεάν δοκιμή {days} ημερών',
  'modal.close_aria': 'Κλείσιμο',
  'modal.continue': 'Συνέχεια',
  'modal.error_generic': 'Κάτι πήγε στραβά',
  'modal.loading': 'Φόρτωση…',
  'modal.purchase_restored_subtitle': 'Όλα έτοιμα — απόλαυσέ το!',
  'modal.purchase_restored_title': 'Καλώς ήρθατε ξανά',
  'modal.purchase_success_subtitle': 'Όλα έτοιμα — απόλαυσέ το!',
  'modal.purchase_success_title': 'Πληρωμή ελήφθη',
  'modal.verifying_subscription': 'Έλεγχος συνδρομής…',
  'nav.back': '← Πίσω',
  'nav.back_aria': 'Πίσω',
  'offer.limited_time': 'Προσφορά περιορισμένου χρόνου',
  'payment.awaiting_title': 'Ολοκληρώστε την πληρωμή στη νέα καρτέλα',
  'payment.checking': 'Έλεγχος…',
  'payment.ive_paid': 'Έχω πληρώσει',
  'payment.open_checkout_again': 'Άνοιγμα πληρωμής ξανά',
  'payment.open_checkout_button': 'Άνοιγμα πληρωμής',
  'pricing.free_trial_days': 'Δωρεάν δοκιμή {days} ημερών',
  'pricing.included_per': 'Περιλαμβάνεται ανά {interval}:',
  'pricing.interval.day': 'ημέρα',
  'pricing.interval.lifetime_short': 'ισόβιο',
  'pricing.interval.month': 'μήνας',
  'pricing.interval.period': 'περίοδος',
  'pricing.interval.week': 'εβδομάδα',
  'pricing.interval.year': 'έτος',
  'pricing.money_back': 'Εγγύηση επιστροφής χρημάτων 30 ημερών',
  'pricing.most_popular': 'Δημοφιλέστερο',
  'pricing.no_prices': 'Δεν υπάρχουν διαθέσιμες τιμές.',
  'pricing.plan_label.daily': 'ΗΜΕΡΗΣΙΟ ΠΛΑΝΟ',
  'pricing.plan_label.lifetime': 'εφ\' όρου ζωής',
  'pricing.plan_label.monthly': 'μηνιαίο πλάνο',
  'pricing.plan_label.weekly': 'εβδομαδιαίο πλάνο',
  'pricing.plan_label.yearly': 'ετήσιο πλάνο',
  'pricing.plans_aria': 'Πλάνα',
  'session.contact_support': 'Επικοινωνία υποστήριξης',
  'session.restore_purchases': 'Επαναφορά αγορών',
  'session.sign_out': 'Αποσύνδεση',
  'session.signed_in_as_prefix': 'Συνδεδεμένος ως',
  'session.signing_out': 'Αποσύνδεση…',
  'support.attachments_label': 'Συνημμένα',
  'support.close_button': 'Κλείσιμο',
  'support.done_button': 'Έτοιμο',
  'support.email_placeholder': 'Εισάγετε το email σας',
  'support.heading': 'Υποστήριξη',
  'support.instruction': 'Παρακαλώ συμπληρώστε την παρακάτω φόρμα για να υποβάλετε το αίτημα υποστήριξης.',
  'support.invalid_email': 'Μη έγκυρο email',
  'support.message_length': '1–5000 χαρακτήρες',
  'support.message_placeholder': 'Εισάγετε το μήνυμά σας',
  'support.required': 'Υποχρεωτικό',
  'support.send_another': 'Αποστολή άλλου αιτήματος',
  'support.send_button': 'Αποστολή',
  'support.sending': 'Αποστολή…',
  'support.subject_length': '3–200 χαρακτήρες',
  'support.subject_placeholder': 'Εισάγετε το θέμα',
  'support.success_heading': 'Το αίτημα υποβλήθηκε',
  'support.success_message_prefix': 'Λάβαμε το μήνυμά σας και θα απαντήσουμε στο'
} as const;

export default el;
